import React from 'react';
import './Title.css';

const Title = () => {
    return <h1 className='Title'>mixTape</h1>
}

export default Title;